<div (click)="open()" class="gup-O-link -secondary">
    {{ label }}
    <div class="gup-C-colorPicker__colorsPanel">
        <span *ngIf="showColorPreview"
              [style.background-color]="selectedColor"
              class="gup-C-colorPicker__color">
        </span>
    </div>

</div>

<ng-template #colorPicker="cdkPortal" cdkPortal>
    <div class="gup-C-colorPicker">
        <div class="gup-C-colorPicker__colorsPanel"
             [style.height]="colorsList.length < 15 ? '100%' : 'initial'">
            <div *ngFor="let item of colorsList"
                 [style.background-color]="colorsListFunction(item)"
                 (click)="selectColor(item)"
                 class="gup-C-colorPicker__color">
            </div>
        </div>
    </div>
</ng-template>
